import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'src/app/core/services/dialog.service';
import { Store } from '@ngrx/store';

import { DialogMode } from '../../../../shared/atlas-dialog/enums/dialog-mode.enum';
import { DialogWidth } from '../../../../shared/atlas-dialog/enums/dialog-width.enum';

import { AddScenarioDialogComponent } from '../add-scenario-dialog/add-scenario-dialog.component';
import { ScenarioChangePendingConfirmationDialogComponent } from '../scenario-change-pending-confirmation-dialog/scenario-change-pending-confirmation-dialog.component';

import * as fromScenarioStore from 'src/app/spatial-modeller-store';
import { SpatialModellerDataService } from 'src/app/spatial-modeller/services/spatial-modeller-data.service';
import { ExportService } from 'src/app/spatial-modeller/services/spatial-modeller-reporting.service';
import { spatialModellerReportCancelled } from 'src/app/spatial-modeller-store/actions/sm-report.actions';
import { spatialModellerTestCancelled } from 'src/app/spatial-modeller-store/actions/spatial-modeller-test.actions';
import { ScenarioActionGuardService } from 'src/app/spatial-modeller/services/scenario-action-guard.service';

@Component({
  selector: 'atlas-add-scenario',
  templateUrl: './add-scenario.component.html',
  styleUrls: ['../less/scenario-management-button.component.less'],
  standalone: false
})
export class AddScenarioComponent {
  @Input() disabled: boolean | null = false;
  @Output() addScenarioClicked = new EventEmitter();

  constructor(
    public dialogService: DialogService,
    private scenarioGuard: ScenarioActionGuardService
  ) {}

  onOpenNewScenarioDialog() {
    this.scenarioGuard.handleAction(
      () => this.openAddScenarioDialog(),
      $localize`:@@changeScenario:Change scenario`
    );
  }

  private openAddScenarioDialog(): void {
    this.dialogService.show(AddScenarioDialogComponent, {
      width: DialogWidth.Small,
      panelClass: 'dialog-full-width-height',
      data: {
        entityName: $localize`:@@scenarioEntityName:Scenario`,
        mode: DialogMode.Add,
        headerPrefix: $localize`:@@createScenarioHeaderPrefix:Create a new`,
        affirmativeButtonText: $localize`:@@createAffirmativeButtonText:Create`
      },
      disableClose: true
    });
  }
}
